export default __webpack_public_path__ + "static/media/phros-logo-wrapped.989135fa.png";